const hubMenuContainer = document.querySelector(".hubmenu__container");
if (hubMenuContainer) {
  const gap = parseFloat(getComputedStyle(hubMenuContainer).rowGap);
  const items = [...hubMenuContainer.childNodes].filter((c) => c.nodeType === 1);
  let columns = 0;
  const manageMasonry = () => {
    let columnsCount = getComputedStyle(hubMenuContainer).gridTemplateColumns.split(" ").length;
    if (columns !== columnsCount) {
      columns = columnsCount;
      items.forEach((item) => item.style.removeProperty("margin-top"));
      if (columns > 1) {
        for (let i = columnsCount; i < items.length; i++) {
          const currentItem = items[i];
          const aboveItem = items[i - columnsCount];
          const aboveItemBottomEdge = aboveItem.offsetTop + aboveItem.offsetHeight;
          const currentItemTopEdge = currentItem.offsetTop;
          const offset = aboveItemBottomEdge + gap - currentItemTopEdge;
          currentItem.style.marginTop = `${offset}px`;
        }
      }
    }
  };
  document.addEventListener("DOMContentLoaded", manageMasonry, false);
  window.addEventListener("resize", manageMasonry, false);
}
